//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The ticket links model
* 
* @param appleWallet The apple wallet link (pkpass)
* @param googleWallet The google wallet link (event pass)
* @param pdfDownload The download link
*/
@Serializable

data class TicketLinks (


      /* The apple wallet link (pkpass) */
    @SerialName(value = "appleWallet") val appleWallet: kotlin.String? = null,


      /* The google wallet link (event pass) */
    @SerialName(value = "googleWallet") val googleWallet: kotlin.String? = null,


      /* The download link */
    @SerialName(value = "pdfDownload") val pdfDownload: kotlin.String? = null


) {




  }

